@if (isOpen()) {
  <nf-dialog #dialog [title]="text().title" size="full" (closed)="closed.emit()">
    <div data-testid="nf-server-response-modal" class="flex min-w-0 flex-col gap-3">
      @if (response().status !== undefined) {
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-testid="nf-response-meta">
          <sk-badge [variant]="statusVariant()">{{ response().status }}</sk-badge>
          @if (response().method) {
            <span translate="no" class="rounded bg-sk-surface-raised px-1.5 py-0.5 font-mono text-xs font-semibold text-sk-text-secondary">{{ response().method }}</span>
          }
          @if (response().url) {
            <span translate="no" class="min-w-0 flex-1 truncate font-mono text-xs text-sk-text-secondary" [title]="response().url ?? ''">{{ path() }}</span>
          }
          @if (response().responseTimeMs !== undefined) {
            <span class="text-xs tabular-nums text-sk-text-secondary">{{ response().responseTimeMs }} ms</span>
          }
          @if (response().timestamp; as when) {
            <span class="text-xs tabular-nums text-sk-text-secondary">{{ when | nfDate: dateLocale() : 'timeSeconds' }}</span>
          }
        </div>
      }

      @if (tabs().length > 0) {
        <div role="tablist" class="flex gap-0 border-b border-sk-border" [attr.aria-label]="text().contentLabel">
          @for (t of tabs(); track t.id) {
            <button
              type="button"
              role="tab"
              class="border-b-2 px-3 py-2 text-sm font-medium transition-colors"
              [id]="'nf-response-tab-' + t.id"
              [attr.aria-selected]="activeTab()?.id === t.id"
              [attr.aria-controls]="'nf-response-panel'"
              [attr.tabindex]="activeTab()?.id === t.id ? 0 : -1"
              [class.border-sk-primary]="activeTab()?.id === t.id"
              [class.text-sk-text]="activeTab()?.id === t.id"
              [class.border-transparent]="activeTab()?.id !== t.id"
              [class.text-sk-text-secondary]="activeTab()?.id !== t.id"
              (click)="select(t.id)"
              (keydown)="onTabKeydown($event, t.id)">
              {{ t.label }}
            </button>
          }
        </div>
      }

      @if (truncation(); as notice) {
        <p
          role="status"
          class="rounded-md border border-status-warning-border bg-status-warning-bg px-3 py-2 text-xs text-status-warning-fg"
          data-testid="nf-response-truncation">
          {{ notice }}
        </p>
      }

      <div id="nf-response-panel" role="tabpanel" [attr.aria-labelledby]="activeTab() ? 'nf-response-tab-' + activeTab()?.id : null" class="min-w-0">
        @if (activeTab()?.id === 'summary') {
          <div class="flex flex-col gap-3 text-sm" data-testid="nf-response-summary">
            @if (view().kind === 'message') {
              <pre class="max-h-[40vh] overflow-auto font-sans text-sm font-medium text-sk-text whitespace-pre-wrap [overflow-wrap:anywhere]" tabindex="0">{{ limited().text }}</pre>
            } @else {
              <p class="font-medium text-sk-text [overflow-wrap:anywhere]">{{ messageShown() }}</p>
            }
            @if (view().processId; as id) {
              <p class="text-xs text-sk-text-secondary">Process ID: <span translate="no" class="font-mono text-sk-text [overflow-wrap:anywhere]">{{ id }}</span></p>
            }
            @if (view().errorId; as id) {
              <p class="text-xs text-sk-text-secondary">{{ text().errorId }} <span translate="no" class="font-mono text-sk-text [overflow-wrap:anywhere]">{{ id }}</span></p>
            }
            @if (view().detailMessage; as detail) {
              <p class="text-xs text-sk-text-secondary">{{ text().detail }} <span class="text-sk-text [overflow-wrap:anywhere]">{{ detail }}</span></p>
            }
            @if (view().kind !== 'message' && limited().text) {
              <pre translate="no" class="max-h-[40vh] overflow-auto rounded-md border border-sk-border bg-sk-surface-sunken p-3 font-mono text-xs leading-5 text-sk-text whitespace-pre-wrap [overflow-wrap:anywhere]" tabindex="0">{{ limited().text }}</pre>
            }
          </div>
        } @else if (activeTab()) {
          @if (tabIsEmpty()) {
            <p class="py-6 text-center text-sm text-sk-text-secondary" data-testid="nf-response-empty">{{ emptyMessage() }}</p>
          } @else {
            <nf-monaco-editor
              [value]="limited().text"
              [readOnly]="true"
              [validate]="false"
              [theme]="editorTheme()"
              (escapePressed)="dialog.requestClose()"
              height="min(720px, max(14rem, calc(90vh - 24rem)))" />
          }
        } @else {
          <p class="py-6 text-center text-sm text-sk-text-secondary [overflow-wrap:anywhere]" data-testid="nf-response-empty">{{ emptyMessage() }}</p>
        }
      </div>
    </div>

    @if (canAskLeapBot()) {
      <sk-button nf-dialog-actions variant="secondary" size="sm" (skClick)="askLeapBot.emit()">
        <sk-icon name="message-square" size="sm" />
        {{ text().askLeapBot }}
      </sk-button>
    }
    <sk-button nf-dialog-actions variant="secondary" size="sm" (skClick)="copy()">
      <sk-icon name="copy" size="sm" />
      {{ text().copy }}
    </sk-button>
    <sk-button nf-dialog-actions variant="primary" size="sm" (skClick)="closed.emit()">{{ text().close }}</sk-button>
  </nf-dialog>
}
